import React, {createContext, useContext, useMemo} from "react";

// Identity only, never an access grant. A route guard has already resolved this
// slug; descendants still establish their own live membership and capabilities.
const OrganizationPermissionScope = createContext(null);
export function OrganizationPermissionScopeProvider({requestKey, orgId, children}) {
  const value=useMemo(()=>({requestKey,orgId}),[requestKey,orgId]);
  return <OrganizationPermissionScope.Provider value={value}>{children}</OrganizationPermissionScope.Provider>;
}
export function useResolvedPermissionOrgId(requestKey) {
  const scope=useContext(OrganizationPermissionScope);
  const key=String(requestKey || "").trim();
  return scope?.orgId && (scope.requestKey===key || scope.orgId===key) ? scope.orgId : "";
}
